
<div class="site-selection pa-2 pl-4 mt-1">
    <div class="v-flex">
        <v-text-field
            hide-details
            class          = "mt-0 pt-3 pr-2 mb-3"
            @input         = "onInput"
            @click:append  = "fullsearch=!fullsearch"
            :append-icon   = "fullsearch ? 'fas fa-search-plus' : 'fas fa-search'"
            v-model        = "sitesearch"
            :label         = "fullsearch ? 'Volltextsuche' : 'Fabrik-Nr.'"
            autocomplete   = "off"
            autocorrect    = "off"
            autocapitalize = "off"
            spellcheck     = "false"
        />
    </div>

    <div class="site-selection-content">
        <drag
            v-for="(item, index) in selectable"
            @cut       = "onCut(item)"
            :key       = "item.id"
            :data      = "item"
            type       = "inb-message-selectable"
            @dragstart = "onDragStart"
            @dragend   = "onDragEnd"
        >
            <c-site-selection-card
                :site  = "item"
                style  = "width: 300px;"
                :class = "index < selectable.length-1 ? 'mb-2' : ''"
            />
        </drag>
    </div>
</div>
